export default "__VITE_ASSET__Cdz5CI44__"